export default function CsharpHome() {
  return (
    <h2>Csharp Home</h2>
  );
}
